import { AxiosInstance } from 'axios';
import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import {
  GroupUserAddRequest,
  GroupUserAddResponse,
  GroupUserSearchRequest,
  GroupUserSearchResponse,
  GroupUserRemoveRequest,
  GroupUserRemoveResponse,
} from './GroupUserService.types';

export class GroupUserService implements Pick<BaseRequestEndpoints, 'search'> {
  instance: AxiosInstance;
  prefix: string;
  constructor(instance: AxiosInstance, prefix: string) {
    this.instance = instance;
    this.prefix = prefix;
  }

  add(request: GroupUserAddRequest) {
    return this.instance.post<GroupUserAddResponse>(
      `${this.prefix}/${request.groupId}/user/${request.userId}`,
    );
  }

  search(request: GroupUserSearchRequest) {
    return this.instance.get<GroupUserSearchResponse>(
      `${this.prefix}/${request.routeParams.groupId}/users`,
      {
        params: request.queryParams,
      },
    );
  }

  remove(request: GroupUserRemoveRequest) {
    return this.instance.delete<GroupUserRemoveResponse>(
      `${this.prefix}/${request.groupId}/user/${request.userId}`,
    );
  }
}
